import { ReactElement } from "react";

import { Anchor } from "@newsela/angelou";

import {
  iconAndLabelContainerCss,
  supportCenterAnchorCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterItem/SupportCenterItem.styles";

const SupportCenterItem = ({
  title,
  href,
  ItemIcon,
  openInNewTab,
}: ISupportCenterItem) => {
  return (
    <li>
      <Anchor
        href={href}
        openInNewTab={openInNewTab}
        __cssFor={supportCenterAnchorCss}
      >
        <div css={iconAndLabelContainerCss}>
          {ItemIcon}
          {title}
        </div>
      </Anchor>
    </li>
  );
};

interface ISupportCenterItem {
  title: string;
  href: string;
  openInNewTab: boolean;
  ItemIcon: ReactElement | null;
}

SupportCenterItem.displayName = "SupportCenterItem";
export { SupportCenterItem };
